import React, { useMemo } from 'react'
import Select from 'react-select'

const menuPortalTarget = typeof document !== 'undefined' ? document.body : null

const baseStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    menu: (base) => ({ ...base, zIndex: 9999 }),
    control: (base, state) => ({
        ...base,
        minHeight: '42px',
        borderColor: state.selectProps.hasError ? '#dc2626' : '#cbd5e1',
        borderRadius: '8px',
        boxShadow: state.isFocused && !state.selectProps.hasError
            ? '0 0 0 3px rgba(37, 99, 235, 0.12)'
            : 'none',
        '&:hover': {
            borderColor: state.selectProps.hasError ? '#dc2626' : '#cbd5e1',
        },
    }),
    valueContainer: (base) => ({
        ...base,
        flexWrap: 'wrap',
        overflow: 'visible',
    }),
    multiValue: (base) => ({
        ...base,
        backgroundColor: '#e0f2fe',
    }),
    multiValueLabel: (base) => ({
        ...base,
        color: '#0c4a6e',
    }),
}

function mergeSelectStyles(custom = {}) {
    const keys = new Set([...Object.keys(baseStyles), ...Object.keys(custom)])
    const merged = {}
    keys.forEach((key) => {
        const baseFn = baseStyles[key]
        const customFn = custom[key]
        if (baseFn && customFn) {
            merged[key] = (base, state) => customFn(baseFn(base, state), state)
        } else {
            merged[key] = customFn || baseFn
        }
    })
    return merged
}

export default function EventTagSelect({ hasError = false, styles, ...props }) {
    const mergedStyles = useMemo(() => mergeSelectStyles(styles), [styles])

    return (
        <Select
            {...props}
            hasError={hasError}
            menuPortalTarget={menuPortalTarget}
            menuPosition="fixed"
            styles={mergedStyles}
        />
    )
}
